import axios from '@/api/axios';
import { gql } from '@/api/utils';

export default {
  async fetchPets() {
    try {
      const { petOwner: results } = await axios.post('/', {
        query: gql`
          query _ {
            petOwner {
              pets {
                id
                name
                status
                qrCodeUrl
              }
              allPets: pets(all: true) {
                name
                status
              }
            }
          }
        `,
      });
      return Promise.resolve(results);
    } catch (error) {
      return Promise.reject({ error: error.message });
    }
  },
  async getBreeds() {
    try {
      const { getBreeds: results } = await axios.post('/', {
        query: gql`
          query {
            getBreeds {
              breeds
            }
          }
        `,
      });
      return Promise.resolve(results?.breeds);
    } catch (error) {
      return Promise.reject({ error: error.message });
    }
  },
  async addPet(payload) {
    try {
      const { addPet: results } = await axios.post('/', {
        query: gql`
          mutation addPet($payload: AddPetDetails!) {
            addPet(petDetails: $payload) {
              id
              uuid
            }
          }
        `,
        variables: { payload },
      });
      return Promise.resolve(results);
    } catch (exception) {
      const error = exception.message?.[0];

      if (!error) {
        return;
      }

      throw {
        message: error?.message,
        code: error?.extensions?.code,
      }
    }
  },
  async removeImage({ petId, imageId }) {
    try {
      const query = gql`
        mutation removePetImage($petId: ID!, $imageId: ID!) {
          removePetImage(petId: $petId, imageId: $imageId) {
            id
          }
        }
      `;

      const variables = { petId, imageId };
      const { removePetImage: results } = await axios.post(`/`, {
        query,
        variables,
      });
      return Promise.resolve(results);
    } catch (error) {
      return Promise.reject({
        message: error.message[0].message,
      });
    }
  },
};
